import React from 'react';

import { Group } from './Navbar.styled';

import Logo from './Logo';
import Menu from './Menu';
import Notifications from './Notifications';

import { useNavbar } from './state';
import { useNotifications } from './Notifications/state';
import Cooperation from './Cooperation';
import Logout from './Logout';

function NavbarDefault() {
  const {
    navbarProps: {
      show,
      logo,
      cooperation,
      logout,
    },
  } = useNavbar();
  const { notifications } = useNotifications();
  return (
    <>
      <Logo {...logo} />
      <Group>
        {show?.logout && <Logout onConfirm={logout} />}
        {show?.notifications && <Notifications badge={notifications.unreadCount} />}
        {show?.menu && <Menu />}
      </Group>
      {cooperation && <Cooperation {...cooperation} />}
    </>
  );
}

export default NavbarDefault;
